import Svg, { G, Path, Defs, ClipPath, Rect } from 'react-native-svg'
import type { SvgProps } from 'react-native-svg'

export function DuplicateIcon(props: SvgProps) {
  return (
    <Svg width={16} height={17} viewBox="0 0 16 17" fill="none" {...props}>
      <G clipPath="url(#clip0_10223_21183)">
        <Path
          d="M13.3335 5.83325H6.66683C5.93045 5.83325 5.3335 6.43021 5.3335 7.16659V13.8333C5.3335 14.5696 5.93045 15.1666 6.66683 15.1666H13.3335C14.0699 15.1666 14.6668 14.5696 14.6668 13.8333V7.16659C14.6668 6.43021 14.0699 5.83325 13.3335 5.83325Z"
          stroke={props.color ?? '#898D8F'}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M2.66683 11.1666C1.9335 11.1666 1.3335 10.5666 1.3335 9.83325V3.16659C1.3335 2.43325 1.9335 1.83325 2.66683 1.83325H9.3335C10.0668 1.83325 10.6668 2.43325 10.6668 3.16659"
          stroke={props.color ?? '#898D8F'}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_10223_21183">
          <Rect width={16} height={16} fill="white" transform="translate(0 0.5)" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}
